import React, { useState, useEffect } from "react";
import axios from "../context/axiosConfig";
import requireAuth from "../context/requireAuth";
import { useParams, useNavigate } from "react-router-dom";

function EditRoom() {
    const [roomData, setRoomData] = useState(null);
    const [roomId, setRoomId] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();


    const org_id = localStorage.getItem("organization");

    useEffect(() => {
        const fetchRoomData = async () => {
            try {
                const response = await axios.get(`orgs/${org_id}/rooms/${id}`, { withCredentials: true });
                setRoomData(response.data);
                setRoomId(response.data.org_room_no);
            } catch (error) {
                // Handle error
            }
        };

        fetchRoomData();
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await axios.patch(`orgs/${org_id}/rooms/${id}`, {
                room_name: event.target.roomName.value,
                roomlocation: event.target.roomLocation.value,
                designation: event.target.designation.value,
                // commisionedby: null,
                // substrateid: null,
                // equipmentid: null,
                // ipmid: null,
                projectcode: event.target.projectCode.value,
                cycleperiod: event.target.cyclePeriod.value,
                description: event.target.description.value,
                size_x: parseInt(event.target.size_x.value),
                size_y: parseInt(event.target.size_y.value),
                size_z: parseInt(event.target.size_z.value),
            }, {
                withCredentials: true
            });
            // Handle successful patch request
        } catch (error) {
            console.error("Error updating room:", error);
        }
        navigate(-1);
    };

    return roomData ? (
        <div className="bodyContent">
            <h1 className="title">Edit Room {roomId}</h1>
            <div className="editFormDiv">
                <form onSubmit={handleSubmit} className="editForm">
                    <label htmlFor="roomName">Room Name</label>
                    <input
                        type="text"
                        name="roomName"
                        id="roomName"
                        className="editInput newMaintenanceInput"
                        defaultValue={roomData.room_name}
                    />
                    <label htmlFor="roomLocation">Room Location</label>
                    <input
                        type="text"
                        name="roomLocation"
                        id="roomLocation"
                        className="editInput newMaintenanceInput"
                        defaultValue={roomData.roomlocation}
                        readOnly
                    />
                    <br />
                    <label htmlFor="designation">Designation</label>
                    <input
                        type="text"
                        name="designation"
                        id="designation"
                        className="editInput newMaintenanceInput"
                        defaultValue={roomData.designation}
                    />
                    <br />
                    <label htmlFor="projectCode">Project Code</label>
                    <input
                        type="text"
                        name="projectCode"
                        id="projectCode"
                        className="editInput newMaintenanceInput"
                        defaultValue={roomData.projectcode}
                    />
                    <br />
                    <label htmlFor="cyclePeriod">Cycle Period</label>
                    <input
                        type="text"
                        name="cyclePeriod"
                        id="cyclePeriod"
                        className="editInput newMaintenanceInput"
                        defaultValue={roomData.cycleperiod}
                    />
                    <br />
                    <label htmlFor="description">Description</label>
                    <textarea
                        name="description"
                        id="description"
                        className="editInput newMaintenanceInput"
                        cols="30"
                        rows="10"
                        defaultValue={roomData.description}
                    ></textarea>
                    <br />
                    <label htmlFor="size_x">Columns</label>
          <input
            id="size_x"
            name="size_x"
            type="text"
            className="editInput newMaintenanceInput"
            defaultValue={roomData.size_x}
          />
          <br />

          {/* size_x / size_y / size_z remain text inputs as requested */}
          <label htmlFor="size_y">Rows</label>
          <input
            id="size_y"
            name="size_y"
            type="text"
            className="editInput newMaintenanceInput"
            defaultValue={roomData.size_y}
          />
          <br />

          <label htmlFor="size_z">Floors</label>
          <input
            id="size_z"
            name="size_z"
            type="text"
            className="editInput newMaintenanceInput"
            defaultValue={roomData.size_z}
          />
          <br />

                    <input type="submit" value="Edit Room" className="maintenanceFormSubmit" />
                </form>
            </div>
        </div>
    ) : (
        <div>Loading room data...</div>
    );
}
export default requireAuth(EditRoom);

